<template>
  <div>
    <label class="slds-form-element__label" v-if="label">
      <abbr class="slds-required" title="required" v-if="required || (validation && validation.includes('required'))">*</abbr>
      {{ label }}
    </label>

    <Tooltip :text="tooltip" v-if="tooltip" :direction="tooltipDirection" />

    <!-- No label -->
    <label class="slds-form-element__label" for="select-01" v-if="noLabel">
      {{nbsp}}
    </label>
    <div class="slds-form-element__control" :class="classes">
      <div class="slds-checkbox" v-if="type === 'checkbox'">
        <span class="slds-checkbox slds-checkbox_standalone">
          <input type="checkbox" v-model="localValue" @change="handleInput" :disabled="disabled" ref="input" />
          <span class="slds-checkbox_faux"></span>
        </span>
      </div>

      <svg class="slds-icon slds-input__icon slds-input__icon_left slds-icon-text-default" v-if="hasLeftIcon">
        <slot name="leftIcon" />
      </svg>

      <template v-if="type === 'date'">
        <input
          :disabled="disabled"
          :placeholder="placeholder"
          @blur="handleBlur"
          @focus="focussed = true"
          @input.prevent
          class="slds-input"
          ref="input"
          type="text"
          v-model="localDateValue" />

        <div class="slds-input__icon-group slds-input__icon-group_right">
          <button class="slds-button slds-button_icon slds-input__icon slds-input__icon_right slds-m-right--large" tabindex="-1" @click="resetValue"  v-if="focussed && !disabled">
            <svg class="slds-button__icon slds-icon-text-light" aria-hidden="true">
              <use xlink:href="../../assets/symbols.svg#clear"></use>
            </svg>
            <span class="slds-assistive-text">{{$t('action.clear')}}</span>
          </button>
          <date-picker v-if="!disabled" v-model="localValue" @input="handleInput" :input-props="dateInputProps" :masks="{ L: $t('general.dateFormat') }" :popover="{ placement: 'left', visibility: 'click' }">
            <button class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" tabindex="-1">
              <svg class="slds-button__icon slds-icon-text-light" aria-hidden="true">
                <use xlink:href="../../assets/symbols.svg#event"></use>
              </svg>
            </button>
          </date-picker>
        </div>
      </template>

      <template v-if="type !== 'checkbox' && type !== 'date'">
        <input
          :disabled="disabled"
          :min="min"
          :type="type"
          :placeholder="placeholder"
          @blur="handleBlur"
          @focus="focussed = true"
          @keyup.enter="$emit('keyup-enter')"
          @input="handleInput"
          class="slds-input"
          ref="input"
          v-if="type !== 'checkbox'"
          v-model="localValue" />

          <button
            :title="$t('action.clear')"
            @click="resetValue"
            class="slds-button slds-button_icon slds-input__icon slds-input__icon_right"
            tabindex="-1"
            v-if="!hideClearButton && focussed && !disabled && type !== 'date'">
            <svg class="slds-button__icon slds-icon-text-light" aria-hidden="true">
              <use xlink:href="../../assets/symbols.svg#clear"></use>
            </svg>
            <span class="slds-assistive-text">{{$t('action.clear')}}</span>
          </button>
        <span class="slds-form-element__addon" id="fixed-text-addon-post" v-if="fixedTextAddonPost">{{fixedTextAddonPost}}</span>
      </template>
    </div>
    <div class="slds-text-align_right slds-text-body_small" v-if="maxlength">{{(value || '').length}} / {{maxlength}}</div>
    <div class="slds-form-element__help error" v-if="!valid">{{ error }}</div>
  </div>
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Tooltip from './Tooltip'
import Validator from '../../validation/Validator'
import _ from 'lodash'
import moment from 'moment'

export default {
  mixins: [Validator],
  components: {
    DatePicker,
    Tooltip
  },
  created () {
    this.localValue = this.value && this.type === 'date' ? new Date(this.value) : this.value
    if (this.type === 'date') {
      const momentObject = moment(this.localValue)
      if (momentObject.isValid()) {
        this.localDateValue = momentObject.format(this.$t('general.dateFormat'))
      } else {
        // this.localDateValue = ''
      }
    }
  },
  computed: {
    classes () {
      return {
        'slds-has-error': !this.valid,
        'slds-input-has-icon slds-input-has-icon_left-right': (this.hasLeftIcon && this.type !== 'date'),
        'slds-input-has-fixed-addon': this.fixedTextAddonPost,
        'slds-input-has-icon slds-input-has-icon_right': (!this.hasLeftIcon || this.type === 'date'),
        'slds-input-has-icon slds-input-has-icon_left': (this.hasLeftIcon && this.type === 'date')
      }
    },
    dateInputProps () {
      return {
        class: `slds-input slds-input-has-icon slds-input-has-icon_right ${this.valid ? '' : 'slds-has-error'}`,
        disabled: !!this.disabled
      }
    },
    nbsp () {
      return '\xa0'
    }
  },
  data () {
    return {
      focussed: false,
      localDateValue: '',
      localValue: ''
    }
  },
  methods: {
    setDate: _.debounce((vm, text) => {
      const momentObject = moment(text, vm.$t('general.dateFormat'))
      if (momentObject.isValid()) {
        vm.localValue = momentObject.toDate()
      } else {
        vm.localValue = null
      }
    }, 500),
    focus () {
      this.focussed = true
      this.$refs.input.focus && this.$refs.input.focus()
    },
    handleBlur (event) {
      this.$emit('blur', event)
      setTimeout(() => {
        // this.focussed = false
      }, 500)
    },
    handleInput () {
      if(this.type2==='date-carAge'){
         this.localValue = moment(this.localValue).format(this.$t('general.apiDateFormat'))
      }
      this.clearValidationError()
      this.$emit('input', this.localValue)
    },
    resetValue () {
      this.localDateValue = null
      this.$emit('input', '')
    }
  },
  props: {
    disabled: Boolean,
    informativeCampaign: Boolean,
    fixedTextAddonPost: String,
    hasLeftIcon: Boolean,
    hideClearButton: Boolean,
    label: String,
    min: [String, Number],
    noLabel: Boolean,
    maxlength: [String, Number],
    placeholder: String,
    required: Boolean,
    tooltip: String,
    tooltipDirection: {
      type: String,
      default: 'left'
    },
    value: [String, Number, Boolean, Date],
    type: {
      type: String,
      default: 'text'
    },
    type2: String
  },
  watch: {
    disabled (newValue, oldValue) {
      this.clearValidationError()
      if (!oldValue && newValue) {
        this.localDateValue = ''
        this.localValue = ''
      }
      if(this.informativeCampaign)
      {
        this.localValue = this.value
      }
    },
    localDateValue (value) {
      this.setDate(this, value)
    },
    value (value) {
      this.localValue = this.value && this.type === 'date' ? new Date(this.value) : this.value
      if (this.type === 'date') {
        const momentObject = moment(this.localValue)
        if (momentObject.isValid()) {
          this.localDateValue = momentObject.format(this.$t('general.dateFormat'))
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .error {
    color: #C23933;
  }
</style>
